// extracted by mini-css-extract-plugin
export default {"read__more":"styles_read__more__ypIeN"};